'use strict';

import { dataMember, required } from 'santee-dcts';
import { Study } from '../studies';
import { siteDisplayNameRenderer } from '../renderer/site-display-name-renderer';

export class Site {

    @dataMember()
    @required()
    public siteId: number;

    @required({ nullable: true })
    @dataMember()
    public siteNum: string;

    @required({ nullable: true })
    @dataMember()
    public investigatorFullName: string;

    @required({ nullable: true })
    @dataMember()
    public study: Study;

    @required({ nullable: true })
    @dataMember()
    public isFavorite: boolean;

    @required()
    @dataMember()
    public isExtremelyLarge: boolean;

    @required()
    @dataMember()
    public numberOfSubjects: number;

    @dataMember()
    public isAgeProject: boolean;

    @dataMember()
    public ctSiteId: number;

    public toString() {
        return this.description;
    }

    public get description() {
        return siteDisplayNameRenderer({siteNumber: this.siteNum, investigatorFullName: this.investigatorFullName});
    }

    public get siteUrlParameter(): string {
        return this.siteNum || `siteId:${this.siteId}`;
    }
}
